import React, { useState } from 'react';

import { Modal } from 'antd';

import { useLayoutContext } from '@contexts/LayoutContext';

import NwDrawer from '@components/Gui/NwDrawer';
import PlaylistEditor from '@components/PlaylistEditor/PlaylistEditor';
import { PlaylistEditorContextProvider } from '@components/PlaylistEditor/PlaylistEditorContext';
import MobileBookEditor from '@components/PlaylistEditorMobile/MobileBookEditor';

const { confirm } = Modal;

/**
 * Editor di un book. Su mobile usa l'editor dedicato, che porta la propria barra
 * del titolo e quindi non ha bisogno dell'header del drawer; su desktop quello a
 * due pannelli, a tutta larghezza. Con modifiche in sospeso la chiusura chiede conferma.
 */
const BookEditorDrawer = ({ bookID, contactID, onClose, packageID }) => {
    const { isMobile } = useLayoutContext();
    const [isBookTouched, setIsBookTouched] = useState(false);

    const handleClose = () => {
        if (isBookTouched) {
            confirm({
                title: <div>Discard changes and close the drawer?</div>,
                onOk() {
                    onClose();
                },
                onCancel() {},
            });
        } else {
            onClose();
        }
    };

    if (isMobile) {
        return (
            <NwDrawer fixed title={null} padding={0} whiteBg={false} onClose={handleClose}>
                <PlaylistEditorContextProvider
                    selectedModel={contactID}
                    bookToEdit={bookID}
                    onClose={onClose}
                    packageID={packageID}
                >
                    <MobileBookEditor onRequestClose={handleClose} />
                </PlaylistEditorContextProvider>
            </NwDrawer>
        );
    }

    return (
        <NwDrawer width="98vw" title="Edit Book" padding={0} whiteBg={false} onClose={handleClose}>
            <PlaylistEditorContextProvider
                selectedModel={contactID}
                bookToEdit={bookID}
                onClose={onClose}
                packageID={packageID}
            >
                <PlaylistEditor onBookTouched={setIsBookTouched} />
            </PlaylistEditorContextProvider>
        </NwDrawer>
    );
};

export default BookEditorDrawer;
